import { DrawerComponent } from 'components/Drawer';
import styled, { css } from 'styled-components';

export const HeaderBenefits = styled.div`
  ${() => css`
    display: flex;
    flex-shrink: 0;
    min-height: 320px;
    max-height: 320px;
    padding: 2rem;
    flex-direction: column;
    background: linear-gradient(
        360deg,
        #191919 -86.67%,
        rgba(25, 25, 25, 0.5) -3.33%,
        rgba(25, 25, 25, 0) 73.33%
      ),
      url(/assets/backgroundBenefit.png);
    background-size: cover;
    background-position: center;
  `}
`;
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  background: transparent;
  margin-top: 24px;
  align-self: center;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 1rem;
  }
`;
export const ContentContainer = styled.div`
  ${() => css`
    display: grid;
    grid-template-columns: 1fr 300px;
    border-radius: 12px;
    overflow: hidden;
    min-height: 112px;
    border: 0.0625rem solid #d8d8d8;
    border-radius: 0.8rem;
    margin-top: 24px;

    @media (max-width: 800px) {
      grid-template-columns: 1fr;
      min-height: auto;
    }
  `}
`;

export const TextContent = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;

    @media (max-width: 800px) {
      padding: 1.5rem;
    }
  `}
`;

export const ImageContent = styled.div`
  ${() => css`
    display: flex;
    align-items: stretch;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    @media (max-width: 800px) {
      display: none;
    }
  `}
`;
export const Header = styled.div`
  ${() => css`
    gap: 1rem;
    display: flex;
    padding: 2rem;
    flex-shrink: 0;
    background: #f5f5f5;
    flex-direction: column;
    border-bottom: 0.0625rem solid #d8d8d8;
  `}
`;
export const Box = styled.div`
  ${() => css`
    padding: 1.5rem;
    margin-top: 16px;
    margin-bottom: 16px;
    border: 0.0625rem solid #d8d8d8;
    border-radius: 0.8rem;
  `}
`;
export const BoxContent = styled.div`
  ${() => css`
    padding: 1.5rem;
  `}
`;
export const Form = styled.div`
  ${() => css`
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  `}
`;
export const BoxFooter = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}
`;
export const ContentFooter = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    gap: 0.25rem;
  `}
`;

export const StyledDrawer = styled(DrawerComponent)`
  ${() => css`
    display: flex;
    gap: 1.5rem;
    padding: 0 !important;
    flex-direction: column;
    position: relative;
    max-height: 100vh !important;

    &:last-child {
      border-top: 1px solid #d8d8d8;
    }
  `}
`;
export const Infos = styled.div`
  ${() => css`
    gap: 1.5rem;
    display: flex;
    justify-content: space-between;
  `}
`;
export const Profile = styled.div`
  ${({ theme }) => css`
    gap: 1rem;
    display: flex;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: -0.05rem;
    font-size: ${theme.font.sizes.large || '24px'};
  `}
`;

export const Close = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    stroke-width: 3rem;
    stroke: ${theme.colors.neutral.neutral100 || '#000'};
    font-size: ${theme.font.sizes.medium || '16px'};
  `}
`;
export const Subtitle = styled.span`
  ${() => css`
    font-weight: 500;
    line-height: 2rem;

    align-items: center;
    font-size: 16px;
  `}
`;
export const TextInfos = styled.span<{
  color?: string;
  lineWeight?: string;
  size?: string;
  mt?: string;
  cursor?:boolean
}>`
  ${({ color, lineWeight, size, mt ,cursor }) => css`
    font-weight: ${lineWeight ?? '700'};
    line-height: 2rem;
    color: ${color || '#000'};
    align-items: center;
    cursor: ${cursor && "pointer"};
    font-size: ${size ?? '16'}px;
    margin-top: ${mt || '0'};
    text-align: left;
  `}
`;
export const TitleValue = styled.span`
  ${({ theme }) => css`
    font-weight: 500;
    line-height: 2rem;
    display: flex;
    font-size: 12px;
    color: ${theme.colors.neutral.neutral50 || '#808080'};
  `}
`;
export const Value = styled.div`
  ${() => css`
    font-weight: 700;
    line-height: 2rem;
    display: flex;
    font-size: 24px;
  `}
`;
export const SubtitleBold = styled.span<{
  cursor?:boolean
}>`
  ${(cursor) => css`
    font-weight: 700;
    line-height: 2rem;
    cursor: ${cursor && "pointer"};
    font-size: 16px;
  `}
`;
export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%
`;
export const Main = styled.main`
  ${() => css`
    gap: 1.5rem;
    display: flex;
    overflow: auto;
    padding: 16px 32px;
    flex-direction: column;
    height: calc(100% - 185px);
  `}
`;
export const DrawerFooter = styled.div`
  ${() => css`
    border-top: 1px solid #d8d8d8;
    padding: 1rem 2rem;
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    align-items: center;
  `}
`;
export const Toggle = styled.div`
  ${() => css`
    display: flex;
    gap: 1rem;
    border: 0.0625rem solid #d8d8d8;
    border-radius: 16px;
    padding: 4px;
    align-items: center;
    justify-content: center;
  `}
`;
export const Checkbox = styled.input`
  ${({ theme }) => css`
    cursor: pointer;
    width: 16px;
    height: 16px;
    accent-color: ${theme.colors.primary50 || '#298ee6'};
    margin-right: 8px;
  `}
`;
export const ToggleItem = styled.div<{ active: boolean }>`
  ${({ theme, active }) => css`
    padding: 4px 16px;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    color: ${active ? '#fff' : theme.colors.neutral.neutral130};
    background-color: ${active ? theme.colors.primary50 : 'transparent'};
  `}
`;
export const CustomButton = styled.button<{
  variant?: 'primary' | 'secondary' | 'link';
}>`
  ${({ theme, variant = 'primary' }) => css`
    padding: 12px 24px;
    border-radius: ${theme.border.radius || '8px'};
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border: 1px solid;

    ${variant === 'primary' &&
    css`
      background-color: ${theme.colors.primary50};
      color: #ffffff;
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary70};
        border-color: ${theme.colors.primary70};
      }
    `}

    ${variant === 'secondary' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary50};
        color: #ffffff;
      }
    `}

    ${variant === 'link' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border: none;
      padding-top: 0;
      padding-bottom: 0;
      border-radius: 0;

      /* Remove hover effects */
      &:hover {
        background-color: transparent;
        color: ${theme.colors.primary50};
      }
    `}
  `}
`;
